import type { SystemStyleObject } from "@ui/utils/theme-tools";
import { space } from "@ui/design-tokens";

export const headerStyle: SystemStyleObject = {
    fontSize: "desktopHeading4",
    textAlign: "center",
    fontWeight: "bold",
    color: "black",
};

export const headerInlineResultsStyle: SystemStyleObject = {
    fontSize: "desktopHeading4",
    fontWeight: "normal",
};

export const buttonStyle: SystemStyleObject = {};

export const progressBarStyle: SystemStyleObject = {
    height: space["0.2"],
    background: "gray.50",
    "> div": {
        backgroundColor: "black",
    },
};
